/**
 * Radiothérapie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: ONCO
 * Catalogue acts (NGAP Maroc): 43
 */
import { defineSpecialty } from "../types";

export const radiotherapie = defineSpecialty(
{
  "id": "radiotherapie",
  "label": "Radiothérapie",
  "short": "Radiothérapie",
  "scope": "Radiothérapie & curiethérapie",
  "aliases": [
    "ONCO"
  ],
  "doctorSpecs": [
    "Radiothérapie",
    "Oncologie"
  ],
  "featureFlag": "ux.v2.radiotherapie",
  "theme": {
    "primary": "oklch(0.63 0.18 15)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.80 0.15 90)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "planning",
      "label": "Planification",
      "icon": "Crosshair",
      "route": "/clinical/planning",
      "order": 2,
      "requires": [
        "rt"
      ]
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 3,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "planning",
      "label": "Plan",
      "icon": "Crosshair",
      "component": "RtPlanningPanel",
      "order": 1,
      "requires": []
    },
    {
      "id": "dosimetry",
      "label": "Dosimétrie",
      "icon": "Gauge",
      "component": "DosimetryPanel",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Radiothérapie",
    "subSpecialties": [
      "Consultation",
      "Curiethérapie",
      "Radiothérapie externe"
    ],
    "catalogueActs": 43
  },
  "terminology": {
    "icd10": [
      "C00",
      "C50",
      "C60",
      "C73"
    ],
    "loinc": [
      "21868-2",
      "24628-0"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "ct-simulator",
    "linear-accelerator",
    "brachytherapy-system"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default radiotherapie;
